
import Vue from 'vue';
import SearchDropdown from './SearchDropdown.vue';
import SearchFilterBtn from './SearchFilterBtn.vue';
import { ITag } from '../store/state';

interface ISearchTagProps {
	tag: ITag
}

export default Vue.extend<{} ,{} ,{} ,ISearchTagProps>({
	name: 'SearchTag',
	props: {
		tag: {}
	},
  components: {
    SearchDropdown,
		SearchFilterBtn
  }
})
